import React, {useState} from "react";
import Page from "../../components/page/Page";
import useAppContext from "../../hooks/useAppContext";
import Loader from "../../components/loader/Loader";
import "./segments.css";
import NewSegmentModal from "./newSegmentModal/NewSegmentModal";
import EditSegmentModal from "./editSegmentModal/EditSegmentModal";
import EmptyState from "../../components/emptyState/EmptyState";
import {Button} from "antd";
import WhatsappIntegrationButton from "../../components/whatsappIntegrationButton/WhatsappIntegrationButton";
import {useNavigate} from "react-router-dom";

const Segments = () => {
    const [isNewSegmentModalOpen, setIsNewSegmentModalOpen] = useState(false);
    const [editSegmentId, setEditSegmentId] = useState<number | null>(null);
    const { data: { segments, waba } } = useAppContext();
    // console.log("shopSegments: ", shopSegments);
    const isEnabled = waba.isLoaded && !!waba?.data?.waba?.whatsappBusinessAccountId;
    const navigate = useNavigate();

    const toggleEditSegmentModal = (segmentId: number | null) => () => {
        setEditSegmentId(segmentId);
    }

    return (
        <Page
            className="segments-container"
            title="Audience"
            subtitle="Create, edit, and remove audiences. Use it to organize your campaign audience and send more relevant messages."
            primaryAction={{
                label: 'Add Audience',
                action: () => setIsNewSegmentModalOpen(true),
            }}
            secondaryActions={[{
                label: 'campaigns',
                action: () => navigate('/campaigns'),
                isDisabled: !isEnabled,
            }]}
        >
            {segments.isLoading ? <Loader isFullPage={true} /> : segments.data?.length ? <div className="grid-4-cols shop-segments-list">
                {segments.data?.map((segment: any) => <div key={`segment-${segment.id}-thumb`} className="shop-segment-item" onClick={toggleEditSegmentModal(segment.id)}>
                    <div className="title">{segment.title}</div>
                    <div className="label-badge type">{segment.clientsCountEstimation} customer{segment.clientsCountEstimation !== 1 ? 's' : ''}</div>
                    <div className="description">{segment.description}</div>
                </div>)}
            </div> : <EmptyState subTitle="Start by creating your first segment." actions={isEnabled ?
                <Button type="primary" onClick={() => setIsNewSegmentModalOpen(true)} size="large" >Add Segment</Button> :
                <WhatsappIntegrationButton /> } />}
            <NewSegmentModal isOpen={isNewSegmentModalOpen} onClose={() => setIsNewSegmentModalOpen(false)} />
            <EditSegmentModal segmentId={editSegmentId} onClose={toggleEditSegmentModal(null)} />
        </Page>
    )
}

export default Segments;